import React, { useState } from "react";

function MountainViewFAQs() {
  const [activeIndex, setActiveIndex] = useState(null);

  const handleAccordionClick = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const isActive = (index) => activeIndex === index;

  const faqs = [
    {
      question: "What areas do you serve?",
      answer:
        "We proudly serve Mountain View, CA, and surrounding areas, including Palo Alto, Los Altos Hills, San Jose, and Santa Clara County.",
    },
    {
      question: "What types of items do you remove?",
      answer:
        "We remove a wide variety of items, including furniture, appliances, mattresses, construction debris, scrap metal, yard waste, electronics, hot tubs, exercise equipment, and more. We also handle hazardous materials responsibly.",
    },
    {
      question: "Do you offer same-day service?",
      answer:
        "Yes, we offer same-day junk removal services for your convenience. Contact us to check availability!",
    },
    {
      question: "Are your disposal practices eco-friendly?",
      answer:
        "Absolutely! We prioritize eco-friendly disposal methods, including recycling and donating usable items whenever possible.",
    },
    {
      question: "Do you provide free estimates?",
      answer:
        "Yes, we offer free, no-obligation estimates. You can get a quote over the phone or schedule an onsite estimate.",
    },
    {
      question: "How does pricing work?",
      answer:
        "Our pricing is transparent and based on the volume of junk you need removed. We provide upfront pricing with no hidden fees.",
    },
    {
      question: "Can you handle large cleanouts?",
      answer:
        "Yes, we specialize in large cleanouts for homes, offices, estates, and construction sites. We also offer dumpster rentals for bigger projects.",
    },
    {
      question: "Do you offer demolition services?",
      answer:
        "Yes, we provide demolition services for heavy-duty projects, including tear-downs and debris removal.",
    },
    {
      question: "What if I only need one item removed?",
      answer:
        "No problem! We handle single-item removals as well as full-scale cleanouts.",
    },
    {
      question: "Are you licensed and insured?",
      answer:
        "Yes, Junk Droid is fully licensed and insured, ensuring a safe and professional experience.",
    },
    {
      question: "Can you help with moving junk or unwanted items?",
      answer:
        "Yes, we offer moving services for junk and unwanted items, making your move easier and more efficient.",
    },
    {
      question: "How do I schedule a service?",
      answer:
        "You can call us at (408) 539-7261 or fill out our online form to schedule your junk removal service or request a free quote.",
    },
    {
      question: "Do you recycle electronics?",
      answer:
        "Yes, we provide e-waste disposal and electronics recycling services to ensure your old devices are disposed of responsibly.",
    },
    {
      question: "Can you remove yard waste?",
      answer:
        "Yes, we offer yard waste removal services to help you keep your outdoor spaces clean and tidy.",
    },
    {
      question: "What sets Junk Droid apart from other junk removal services?",
      answer:
        "We pride ourselves on fast, reliable, and eco-friendly services, with a focus on customer satisfaction. Our experienced team, transparent pricing, and flexible scheduling make us the top choice for junk removal in Mountain View, CA.",
    },
  ];

  return (
    <div>
      <main>
        <div className="accordion junk-faq-sec">
          {faqs.map((faq, index) => (
            <div
              className={`accordion-item ${isActive(index) ? "active" : ""}`}
              key={index}
            >
              <div
                className="accordion-item-header"
                onClick={() => handleAccordionClick(index)}
                style={{ color: isActive(index) ? "blue" : "#000" }}
              >
                <span className="accordion-item-header-title">
                  <img
                    src={
                      isActive(index)
                        ? "/assets/img/question-mark-yellow.svg"
                        : "/assets/img/_Compound Path_.png"
                    }
                    alt="default"
                    loading="lazy"
                    className="accordion-image"
                  />
                  <p>{faq.question}</p>
                </span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  class="bi bi-chevron-down"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
                    style={{ color: isActive(index) ? "#2d6bd6" : "#000" }}
                  />
                </svg>
              </div>
              <div
                className={`accordion-item-description-wrapper ${
                  isActive(index) ? "open" : ""
                }`}
                style={{ display: isActive(index) ? "block" : "none" }}
              >
                <div className="accordion-item-description">
                  <p>{faq.answer}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </main>
    </div>
  );
}

export default MountainViewFAQs;
